import { render } from "./Product.vue?vue&type=template&id=2fca1e6a"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/components/Product.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fca1e6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fca1e6a', __exports__)) {
    api.reload('2fca1e6a', __exports__)
  }
  
  module.hot.accept("./Product.vue?vue&type=template&id=2fca1e6a", () => {
    api.rerender('2fca1e6a', render)
  })

}


export default __exports__